// Etiquetes, icones i colors dels TipusEvent, compartits entre Inici,
// Fitxar i Històric perquè els tres mostrin exactament el mateix criteri
// visual (CURRENT_TASK.md §5.3: blau = normal/entrada, taronja = pausa).

import {
  faRightToBracket,
  faMugSaucer,
  faPlay,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

export const CH_ETIQUETA_EVENT = {
  ENTRADA: "Entrada",
  INICI_PAUSA: "Inici pausa",
  FI_PAUSA: "Fi pausa",
  SORTIDA: "Sortida",
};

export const CH_ICONA_EVENT = {
  ENTRADA: faRightToBracket,
  INICI_PAUSA: faMugSaucer,
  FI_PAUSA: faPlay,
  SORTIDA: faRightFromBracket,
};

// Classe CSS del cercle d'icona de cada event (colors corporatius).
export const CH_CLASSE_EVENT = {
  ENTRADA: "ch-icona-blau",
  INICI_PAUSA: "ch-icona-taronja",
  FI_PAUSA: "ch-icona-taronja",
  SORTIDA: "ch-icona-fosc",
};

export const CH_ETIQUETA_ESTAT = {
  SENSE_JORNADA_INICIADA: "Encara no has fitxat",
  TREBALLANT: "Treballant",
  EN_PAUSA: "En pausa",
  JORNADA_FINALITZADA: "Jornada finalitzada",
};
